"use client";

import { motion, AnimatePresence } from "framer-motion";
import type { DemoStep } from "../types";

interface NarrativeTextProps {
  step: DemoStep;
  progress: number;
  stepIndex: number;
  totalSteps: number;
}

export function NarrativeText({ step, progress, stepIndex, totalSteps }: NarrativeTextProps) {
  return (
    <div className="flex flex-col items-center gap-3 px-4 pb-1 pt-4">
      {/*
        A narração troca sozinha no tour, e sem isto quem usa leitor de tela não
        recebe o texto. O `aria-live` fica no contêiner, não no parágrafo: o
        `AnimatePresence` remonta o parágrafo a cada passo, e aí cada troca
        viraria anúncio duplicado.
      */}
      <div
        aria-live="polite"
        aria-atomic="true"
        className="flex min-h-12 items-center justify-center px-2"
      >
        <AnimatePresence mode="wait">
          <motion.p
            key={step.id}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            transition={{ duration: 0.35, ease: "easeOut" }}
            className="text-center text-base md:text-lg text-white/80 max-w-[520px] leading-snug"
          >
            {step.narrative}
          </motion.p>
        </AnimatePresence>
      </div>

      <div className="w-full max-w-[320px] h-0.5 bg-white/10 rounded-full overflow-hidden">
        <motion.div
          className="h-full bg-tami-green rounded-full"
          initial={{ width: "0%" }}
          animate={{ width: `${progress}%` }}
          transition={{ duration: 0.05, ease: "linear" }}
        />
      </div>

      <div className="flex gap-2 items-center">
        {Array.from({ length: totalSteps }).map((_, i) => (
          <span
            key={i}
            className={`
              w-1.5 h-1.5 rounded-full transition-all duration-300
              ${i === stepIndex ? "bg-tami-green scale-125" : "bg-white/30"}
            `}
          />
        ))}
      </div>
    </div>
  );
}
